import styled from 'styled-components'

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ListItemWrapper = styled.div`
  ${({ theme }) => `
    border-top: 2px solid ${theme.color.haze};
    
    &:last-child {
      border-bottom: 2px solid ${theme.color.haze};
    }

    a:link, a:hover, a:visited {
      color: ${theme.color.black};
    }
  `}
`

export const GroupNameWrapper = styled.div`
  ${({ theme }) => `
    border-top: 2px solid ${theme.color.haze};
    
    &:first-child {
      border-top: none;
    }
  `}
`
